import React from "react";
import { connect } from "react-redux";
import { LOGOUT } from "../../actions/Constants";
import logo from "../../img/e-registro-logo.png";
import HeaderAlias from "../../components/Layout/HeaderAlias";
import backgroundLogin from "../../img/e-registro-new-login.jpg";

class SuspensaoCadastro extends React.Component {
  render() {
    return (
      <>
        <HeaderAlias></HeaderAlias>
        <div className="login-container login-background" style={{ backgroundImage: `url(${backgroundLogin})` }}>
          <div className="color-line-ereg"></div>
          <div className="login-form">
            <div className="row">
              <div className="col-md-12">
                <div className="hpanel">
                  <div className="panel-body-round">
                    <div className="login-img-container">
                      <img src={logo} alt="Logo" />
                    </div>
                    <div className="text-center" style={{ padding: "20px 10px" }}>
                      <h4>Acesso Suspenso</h4>
                      <p style={{ fontSize: "14px", margin: "20px 0", color: "#555" }}>Sua financeira está com atualização cadastral pendente. Para regularizar, acione contato@aliasnet.com.br.</p>
                      <button className="btn btn-alternative btn-login btn-block" onClick={() => this.props.logout()}>
                        SAIR
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch({ type: LOGOUT }),
});

export default connect(null, mapDispatchToProps)(SuspensaoCadastro);
